import { TripExpense } from '../types/TripExpense';

/**
 * Sums all final expenses (ie those where isQuoted is false)
 * @param expenses
 * @returns
 */
function getFinalExpenseTotal(expenses: TripExpense[]) {
  const finalExpenseTotal =
    expenses
      .filter((e) => !e.isQuoted)
      .reduce((acc, cur) => {
        // eslint-disable-next-line no-param-reassign
        acc += cur.cost && typeof cur.cost === 'number' ? cur.cost : 0;
        return acc;
      }, 0 as number) || 0;
  return finalExpenseTotal;
}

export default getFinalExpenseTotal;
